import App from './App.svelte'
import '../node_modules/biings-ds/build/bds.css'
const app = new App({
	target: document.body
});

export default app
